import React from 'react';
import './FormButton.scss';

interface FormButton {
    buttonId: string;
    buttonType: 'submit' | 'button';
    type?: 'primary' | 'ghost';
    buttonText: string;
    classNames?: String;
    disabled: boolean;
    onClick?: () => void;
}
const FormButton: React.FC<FormButton> = ({
    buttonId,
    buttonType,
    buttonText,
    type = 'primary',
    classNames = '',
    onClick,
    disabled = false,
}) => (
    <button
        className={`form-button ${type} ${classNames}`}
        disabled={disabled}
        type={buttonType}
        id={buttonId}
        onClick={onClick}
    >
        {buttonText}
    </button>
);

export default FormButton;
